import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { jarallaxElement } from 'jarallax';
import styled from 'styled-components';

import CarPageAvatar from '../CarPageAvatar';
import CalculatorRentLong from './CalculatorRentLong';
import CalculatorLeasing from './CaclulatorLeasing';
import SelectInput from './SelectInput';

import '../../styles/components/SectionContact.css';

const LeftWrapper = styled.div`
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 350px;
    z-index: 1;
    border-right: 30px solid white;

    @media (max-width: 767.98px) {
        position: relative;
        margin: 0 auto;
        border: none;
    }
`;

export default class CalculatorWrapper extends Component {
    state = {
        calcType: 'najem'
    };

    onChange = (fieldName, fieldValue) => {
        this.setState(
            {
                [fieldName]: fieldValue
            },
            () => {
                if (this.props.saveCalcData) {
                    this.props.saveCalcData(this.state);
                }
            }
        );
    };

    setScrollMouseMargin() {
        if ($('.section-contact .right-side').length === 1) {
            const fromLeft = $('.section-contact .right-side').offset().left;
            var styleElem = document.head.appendChild(
                document.createElement('style')
            );
            styleElem.innerHTML = `
      .line::before,
      .scroll::before,
      .scroll::after {
        left:${fromLeft}px
      }
      `;
        }
    }

    componentDidMount() {
        (async () => {
            try {
                $(document).ready(() => {
                    jarallaxElement();
                    this.setScrollMouseMargin();
                });
            } catch (err) {
                console.error(err);
            }
        })().catch(err => {
            console.error(err);
        });
    }

    render() {
        jarallaxElement();
        const { carData, rentLong, leasing } = this.props;
        const { calcType } = this.state;

        const options = [];

        if (this.props.calcType.includes('rentLong')) {
            options.push('najem');
        }

        if (this.props.calcType.includes('leasing')) {
            options.push('leasing');
        }

        const disableCarValue = _.get(
            this.props,
            'carData.acf.availableNow.availableNowCheckbox',
            false
        );

        return (
            <div className="split split__rent split__rent--black">
                <div className="section-contact container container-small">
                    <div className="row">
                        <LeftWrapper>
                            <CarPageAvatar carData={carData} />
                        </LeftWrapper>
                        <div className="col-12 col-md-10 offset-md-2 right-side right-side-calc">
                            <div className="row">
                                <div className="col-12 col-md-8 offset-md-4 car-price-list--wrapper">
                                    <SelectInput
                                        name="calcType"
                                        onChange={this.onChange}
                                        selected={this.state.calcType}
                                        selectData={options}
                                        title="Umowa"
                                    />
                                    {calcType === 'najem' && (
                                        <CalculatorRentLong
                                            defaultValues={
                                                this.state.CalculatorRentLong
                                            }
                                            defaultCarPrice={_.get(
                                                this.props,
                                                'carData.acf.prices.originalBasePrice',
                                                ''
                                            )}
                                            disableCarValue={disableCarValue}
                                            onChange={this.onChange}
                                            rentLong={rentLong}
                                            showModal={this.props.showModal}
                                        />
                                    )}
                                    {calcType === 'leasing' && (
                                        <CalculatorLeasing
                                            defaultValues={
                                                this.state.CalculatorLeasing
                                            }
                                            defaultCarPrice={_.get(
                                                this.props,
                                                'carData.acf.prices.originalBasePrice',
                                                ''
                                            )}
                                            disableCarValue={disableCarValue}
                                            onChange={this.onChange}
                                            rentLong={leasing}
                                            showModal={this.props.showModal}
                                        />
                                    )}
                                    {calcType !== 'najem' &&
                                        calcType !== 'leasing' && (
                                            <h2>Default h2</h2>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CalculatorWrapper.defaultProps = {
    calcType: '',
    rentLong: null,
    leasing: null
};

CalculatorWrapper.propTypes = {
    calcType: PropTypes.array,
    rentLong: PropTypes.shape({
        a: PropTypes.string.isRequired,
        b: PropTypes.string.isRequired,
        c: PropTypes.string.isRequired,
        f: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired,
        h: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired
    }),
    leasing: PropTypes.shape({
        a: PropTypes.string.isRequired,
        b: PropTypes.string.isRequired,
        c: PropTypes.string.isRequired,
        f: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired,
        h: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired
    })
};
